"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actions = void 0;

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.function.name");

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _constants = require("./constants");

var _logger = require("@/services/logger/logger.service");

var _helper = require("@/services/helper/helper.service");

var _request = require("@/services/request/request.service");

var _socket = require("@/api/socket.api");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var logger = new _logger.Logger();
var helper = new _helper.Helper();
var actions = {
  setDateRange: function setDateRange(_ref, payload) {
    var commit = _ref.commit;
    commit('SET_START_DATE', payload['startDate']);
    commit('SET_END_DATE', payload['endDate']);
  },
  loadCoreInformation: function loadCoreInformation(_ref2) {
    var commit = _ref2.commit,
        state = _ref2.state,
        rootState = _ref2.rootState,
        dispatch = _ref2.dispatch;
    var lfToken = rootState['authentication']['lfToken'];
    var requestAuth = new _request.Request('application/json', lfToken);
    return requestAuth.getAll([requestAuth.getFullPath('LEGACY_CORE', "setting?type=".concat(process.env.VUE_APP_LMD_COLUMN_KEY))]).then(function (data) {
      commit('SET_CORE_INFORMATION', data);
      return true;
    }).catch(function () {
      return false;
    });
  },
  getUnassignedOrders: function () {
    var _getUnassignedOrders = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref3) {
      var commit, state, rootState, orderAPI, res, data, pagination, dataPagination;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref3.commit, state = _ref3.state, rootState = _ref3.rootState;
              commit('SET_TABLE_LOADING', true);
              orderAPI = helper.getOrderAPI(rootState);
              _context.next = 5;
              return orderAPI.getUnassignedOrders(state, 'lastmile');

            case 5:
              res = _context.sent;

              if (!(!res || res.failed)) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", false);

            case 8:
              // logger.info('getUnassignedOrders');
              data = res && res['data'] ? res['data'] : [];
              commit('SET_UNASSIGNED_ORDERS', data); // Set Pagination

              pagination = helper.cloneDeep(state['pagination']);
              dataPagination = helper.get(res, 'pagination', null);
              pagination['currentPage'] = dataPagination.currentPage;
              pagination['totalData'] = dataPagination.totalData;
              commit('SET_PAGINATION', pagination);
              commit('SET_TABLE_LOADING', false);
              return _context.abrupt("return", true);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function getUnassignedOrders(_x) {
      return _getUnassignedOrders.apply(this, arguments);
    }

    return getUnassignedOrders;
  }(),
  initPlan: function () {
    var _initPlan = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref4) {
      var commit, state, rootState, dispatch, lastMileDeliveryAPI, res, isEmptyPlan, res2, bool2, plan;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref4.commit, state = _ref4.state, rootState = _ref4.rootState, dispatch = _ref4.dispatch;
              lastMileDeliveryAPI = helper.getLastMileDeliveryAPI(rootState);
              _context2.next = 4;
              return lastMileDeliveryAPI.getPlan(state['planDate']);

            case 4:
              res = _context2.sent;

              if (!(!res || res.failed)) {
                _context2.next = 7;
                break;
              }

              return _context2.abrupt("return", false);

            case 7:
              isEmptyPlan = helper.isEmpty(helper.get(res, 'data', {}));

              if (!isEmptyPlan) {
                _context2.next = 14;
                break;
              }

              dispatch('setPlan', {
                isReset: true
              });
              commit('SET_PLAN_EXISTS', false);
              return _context2.abrupt("return", true);

            case 14:
              _context2.next = 16;
              return lastMileDeliveryAPI.getOrdersInPlan({
                orderId: res.data['orderId'] || []
              });

            case 16:
              res2 = _context2.sent;
              bool2 = helper.isEmpty(helper.get(res2, 'data', {}));

              if (!(!res2 || bool2 || res.failed)) {
                _context2.next = 20;
                break;
              }

              return _context2.abrupt("return", false);

            case 20:
              plan = _objectSpread(_objectSpread({}, res.data), {}, {
                planDate: res2.data.code,
                orders: res2.data.orders,
                trucks: res.data.data || []
              });
              delete plan.data;
              commit('SET_PLAN', plan);
              commit('SET_PLAN_INIT_ORDER_IDS', plan.orderId || []);
              commit('SET_PLAN_EXISTS', true);
              logger.info('Get Saved Plan Object', plan);
              return _context2.abrupt("return", true);

            case 27:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function initPlan(_x2) {
      return _initPlan.apply(this, arguments);
    }

    return initPlan;
  }(),
  setPlan: function setPlan(_ref5, payload) {
    var commit = _ref5.commit,
        state = _ref5.state;
    var isReset = payload['isReset'];
    var plan = null;

    if (isReset) {
      plan = {
        code: state.planDate,
        planDate: state.planDate,
        planId: [],
        orders: [],
        trucks: [],
        orderId: []
      };
      logger.info('Get Initial Last Mile Delivery Plan Object', plan);
    }

    commit('SET_PLAN', isReset ? plan : payload['plan']);
    var planOrderIds = [];

    if (isReset) {
      planOrderIds = plan.orderId || [];
    } else {
      planOrderIds = payload['plan']['orders'] ? helper.map(payload['plan']['orders'], 'id') : [];
    }

    commit('SET_PLAN_INIT_ORDER_IDS', planOrderIds);
  },
  resetPlan: function resetPlan(_ref6) {
    var commit = _ref6.commit,
        rootState = _ref6.rootState;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    // logger.info('Reset Plan');
    var p = _objectSpread({}, _constants.DEFAULT_PAGINATION);

    var pageSize = window.localStorage.getItem('pageSize');

    if (!helper.isUndefined(pageSize)) {
      p['pageSize'] = parseInt(pageSize, 10);
    }

    commit('SET_PAGINATION', p);
    commit('SET_SELECTED_LOCATION', null);
    commit('SET_ORDER_FILTERS', []);
    commit('SET_TRUCK_FILTERS', []);
    commit('SET_TO_BE_UNASSIGNED_ORDER_IDS', []);
    commit('SET_UNASSIGNED_ORDERS', []);
    commit('SET_SELECTED_ORDERS', []);
    commit('SET_EXCLUDED_ORDERS', []);
    commit('SET_INCLUDED_ORDERS', []);
    commit('SET_ASSIGNED_DRIVER_CHANGES', false);
    var truckId = null;
    commit('SET_SELECTED_TRUCK', truckId);

    if (payload) {
      // Socket for global trucks
      var socketAPI = new _socket.SocketAPI({
        lfToken: rootState['authentication']['lfToken'] || null,
        customerKey: rootState['authentication']['userInformation']['customerKey'] || ''
      });
      socketAPI.updateLMDGlobalSelectedTrucks({
        userEmail: rootState['authentication']['userInformation']['user']['name'],
        socketId: rootState['common']['socketId'],
        truckId: truckId ? [truckId] : []
      });
    }
  },
  getTrucks: function () {
    var _getTrucks = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref7) {
      var commit, state, rootState, truckAPI, res;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref7.commit, state = _ref7.state, rootState = _ref7.rootState;
              commit('SET_TRUCK_LOADING', true);
              truckAPI = helper.getTruckAPI(rootState);
              _context3.next = 5;
              return truckAPI.getTrucks(state, 'lastmile');

            case 5:
              res = _context3.sent;

              if (!(!res || res.failed)) {
                _context3.next = 8;
                break;
              }

              return _context3.abrupt("return", false);

            case 8:
              // logger.info('getTrucks');
              commit('SET_TRUCKS', res && res['data'] ? res['data'] : []);
              commit('SET_BUFFER_TRUCKS', res && res['data'] ? res['data'] : []);
              commit('SET_TRUCK_LOADING', false);
              return _context3.abrupt("return", true);

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function getTrucks(_x3) {
      return _getTrucks.apply(this, arguments);
    }

    return getTrucks;
  }(),
  getOrderLocationLists: function () {
    var _getOrderLocationLists = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref8, payload) {
      var commit, state, rootState, orderAPI, res, locations;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              commit = _ref8.commit, state = _ref8.state, rootState = _ref8.rootState;
              orderAPI = helper.getOrderAPI(rootState);
              _context4.next = 4;
              return orderAPI.getOrderLocationLists({
                payload: payload,
                dateRangeOption: state['dateRangeOption']
              });

            case 4:
              res = _context4.sent;

              if (!(!res || res.failed)) {
                _context4.next = 7;
                break;
              }

              return _context4.abrupt("return", false);

            case 7:
              locations = helper.get(res, 'data', []);

              if (locations.length > 0) {
                locations.sort(function (a, b) {
                  return a.toLowerCase().localeCompare(b.toLowerCase());
                });
              }

              commit('SET_ORDER_LOCATION_LISTS', locations);
              return _context4.abrupt("return", true);

            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    function getOrderLocationLists(_x4, _x5) {
      return _getOrderLocationLists.apply(this, arguments);
    }

    return getOrderLocationLists;
  }()
};
exports.actions = actions;